export default interface IPremiumFee {
  id: string;
  type: TitleFeesEnum;
  total?: number | null;
}

export enum TitleFeesEnum {
  lenders_policy = 'lenders_policy',
  extended_lenders_policy = 'extended_lenders_policy',
  standard_owners_policy = 'standard_owners_policy',
  homeowners_policy = 'homeowners_policy',
}
